module.exports = {
    LoginSuccess:"登录成功",
    LoginAuthTimeOver:"登录授权超时",
    LoginAuthFail:"登录授权失败",
    LoginNotUser:"帐号不存在!",
    LoginNot:"未登录",
    LoginOK:"登录成功",
    LoginFail:"登录失败",
    SendCodeOK:"验证码已经发送到您手机 ({mobile})",
    SendCodeFail:"验证码发送失败",
    ErrorRequestParameter:"参数有误",
    LoginCodeOverTime:"登录验证码过期失效",
    LoginCodeError:"验证码错误",
    LoginPasswordError:'登录账号或密码错误',
   	LoginAccountDisabled:'登录帐号被禁用',
   	LoginAccountLocked:' 登录帐号被锁定',
   	title:'运营管理系统',
   	scanLoginTitle:'扫码登录',
   	accoutLoginTitle:'账号登录',
   	phoneLoginTitle:'手机验证码登录',
   	account:'账号',
   	password:'密码',
   	accountMsg:'请输入账号名',
   	passMsg:'请输入密码',
   	accountMsg2:'请输入账号或手机号',
   	verification:'验证码',
   	phoneMsg:'请输入手机号',
   	phoneMsg2:'请填写手机号码',
   	phoneCodeMsg:'请输入验证码',
   	Verification:'获取验证码',
   	LoginText:'登录',
   	loginout:'退出',
   	reviseword:'修改密码',
   	oldword:'旧密码',
   	newword:'新密码',
   	oldholder:'请输入旧密码',
   	newholder:'请输入新密码',
   	oldwordMsg:'旧密码不能为空',
   	newwordMsg:'新密码不能为空',
   	loginoutMsg:'操作成功，请重新登录',
   	loginoutTitle:'退出登录',
   	loginoutTitle2:'你确定要退出登录吗',
   	loginoutOk:'退出成功',
   	
   	
}


// WEBPACK FOOTER //
// ./src/i18n/locales/zh-cn/modules/login.js